import React from 'react';
import clsx from 'clsx';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { LocalParticipant, RemoteParticipant, RemoteVideoTrack, LocalVideoTrack } from 'twilio-video';

import BandwidthWarning from '../../BandwidthWarning/BandwidthWarning';
import MicOff from '@material-ui/icons/MicOff';
import Mic from '@material-ui/icons/Mic';

import NetworkQualityLevel from '../../NewtorkQualityLevel/NetworkQualityLevel';
import ParticipantConnectionIndicator from '../ParticipantConnectionIndicator/ParticipantConnectionIndicator';
import PinIcon from '../PinIcon/PinIcon';
import ScreenShare from '@material-ui/icons/ScreenShare';
import VideocamOff from '@material-ui/icons/VideocamOff';

import useParticipantNetworkQualityLevel from '../../../hooks/useParticipantNetworkQualityLevel/useParticipantNetworkQualityLevel';
import usePublications from '../../../hooks/usePublications/usePublications';
import useIsTrackSwitchedOff from '../../../hooks/useIsTrackSwitchedOff/useIsTrackSwitchedOff';
import usePublicationIsTrackEnabled from '../../../hooks/usePublicationIsTrackEnabled/usePublicationIsTrackEnabled';
import useTrack from '../../../hooks/useTrack/useTrack';

import useParticipantsAudioToggle from '../../../hooks/useParticpantsAudioToggle/useParticipantsAudioToggle';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      height: `${(theme.sidebarWidth * 9) / 16}px`,
      overflow: 'hidden',
      cursor: 'pointer',
      '& video': {
        filter: 'none',
      },
      '& svg': {
        stroke: 'black',
        strokeWidth: '0.8px',
      },
    },
    isVideoSwitchedOff: {
      '& video': {
        filter: 'blur(4px) grayscale(1) brightness(0.5)',
      },
    },
    infoContainer: {
      position: 'absolute',
      zIndex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      padding: '0.4em',
      width: '100%',
      background: 'transparent',
    },
    hideVideo: {
      background: 'black',
    },
    identity: {
      background: 'rgba(0, 0, 0, 0.7)',
      padding: '0.1em 0.3em',
      margin: 0,
      display: 'flex',
      alignItems: 'center',
    },
    infoRow: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  })
);

interface ParticipantInfoProps {
  participant: LocalParticipant | RemoteParticipant;
  children: React.ReactNode;
  onClick: () => void;
  isSelected: boolean;
  localParticipantFlag: boolean;
  currentUser:any;
  muteUnmuteParticipant: any;
  activeCalls: any;
  self?:any;
  muteUnmuteSelf?:any;
  muteUnmuteAllParticipants:any
}

export default function ParticipantInfo({ localParticipantFlag, 
  participant, 
  onClick, 
  activeCalls, 
  muteUnmuteAllParticipants,
  muteUnmuteParticipant, 
  muteUnmuteSelf,
  isSelected, 
  children, 
  self,
  currentUser }: ParticipantInfoProps) {
  const publications = usePublications(participant);
  
  const audioPublication = publications.find(p => p.kind === 'audio');
  const videoPublication = publications.find(p => (p.kind === 'video'));
  // p.trackName !== 'screen' && 

  const networkQualityLevel = useParticipantNetworkQualityLevel(participant);
  const isAudioEnabled = usePublicationIsTrackEnabled(audioPublication);
  const isVideoEnabled = Boolean(videoPublication);
  const isScreenShareEnabled = publications.find(p => p.trackName === 'screen');

  const videoTrack = useTrack(videoPublication);
  const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack as LocalVideoTrack | RemoteVideoTrack);
  const [isParticipantsAudioEnabled, toggleParticipantsAudio] = useParticipantsAudioToggle();

  const classes = useStyles();
  let participantName = participant.identity;

  // if(participantName){
  //   participantName = participantName.split("_")[0];
  // }
  
  //onClick={onClick}
    return (
    <div onClick={onClick}
      className={clsx(classes.container, {
        [classes.isVideoSwitchedOff]: isVideoSwitchedOff,
      })}
     
      data-cy-participant={participant.identity}
    >
      <div className={clsx(classes.infoContainer, { [classes.hideVideo]: !isVideoEnabled })}>
        <div className={classes.infoRow}>
          <NetworkQualityLevel qualityLevel={networkQualityLevel} />
        </div>
        <div>
          
          {self && self == true && !isAudioEnabled && muteUnmuteAllParticipants && <MicOff data-cy-audio-mute-icon  onClick={()=> muteUnmuteSelf()} />}
          {self && self == true && isAudioEnabled && muteUnmuteAllParticipants  && <Mic data-cy-audio-mute-icon  onClick={()=> muteUnmuteSelf()} />}


          {!self && !isAudioEnabled && muteUnmuteAllParticipants && <MicOff data-cy-audio-mute-icon  onClick={()=> muteUnmuteParticipant(currentUser, false, participant, activeCalls)} />}
          {!self && isAudioEnabled && muteUnmuteAllParticipants  && <Mic data-cy-audio-mute-icon  onClick={()=> muteUnmuteParticipant(currentUser, true, participant, activeCalls)} />}

          {!isAudioEnabled && !muteUnmuteAllParticipants && <MicOff data-cy-audio-mute-icon   />}
          {isAudioEnabled && !muteUnmuteAllParticipants  && <Mic data-cy-audio-mute-icon  />}


          {!isVideoEnabled && <VideocamOff />}
          {isScreenShareEnabled && <ScreenShare />}
          {isSelected && <PinIcon />}
        </div>
      </div>
      {isVideoSwitchedOff && <BandwidthWarning />}
      {children}
    </div>
  );
}
